<div class="md-input-container">
    <mat-form-field class="mat-form-withtooltip end-client-width">
        <mat-label>End Client</mat-label>
        <mat-select [(ngModel)]="value" [(value)]="value" [disabled]="disabled || isDisabled" 
            (openedChange)="onOpen($event)"
            [compareWith]="objectComparison"
            [panelClass]="isLoading || !isOpen ? 'hide-dummy-option' : ''"
            name="endClient_id"
            #endClient_id = "ngModel"
            [required]="isRequired" 
            activeonly="activeonly"
        >
            <mat-option *ngIf="(!items || !items.length)" class="minh88" disabled>
                <div class="select-placeholder-container">
                    <mat-spinner class="spinner" diameter="20"></mat-spinner>
                </div>
            </mat-option>
            <mat-option *ngFor="let item of items" [value]="item">{{item.Name}}</mat-option>
        </mat-select>
        <mat-icon
            *ngIf="helptext!=''"
            [matTooltip]="helptext"
            matTooltipPosition="above" class="ng-scope md-iwgNavbar-theme material-icons">help
        </mat-icon>
        <mat-error *ngIf="!endClient_id.valid && endClient_id.touched && isRequired">Required</mat-error>
    </mat-form-field>
</div>
